// ----------------------------------------------------------------------

/**
 * Overrides MUI's Table component.
 *
 * @param {Object} theme The theme object
 * @returns {Object} The theme overrides
 * @example
 * const themeOverrides = {
 *   MuiTable: {
 *     styleOverrides: {
 *       root: {
 *         // Your CSS styles
 *       },
 *     },
 *   },
 * };
 */
export default function Table(theme) {
  return {
    MuiTableCell: {
      styleOverrides: {
        head: {
          color: theme.palette.text.secondary,
          backgroundColor: theme.palette.background.neutral,
        },
      },
    },
  };
}
